
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_1ucra_17",
  "full-width": "awsui_full-width_8cbea_1ucra_44",
  "refresh": "awsui_refresh_8cbea_1ucra_47",
  "disabled": "awsui_disabled_8cbea_1ucra_53",
  "selected": "awsui_selected_8cbea_1ucra_116",
  "icon": "awsui_icon_8cbea_1ucra_127",
  "with-text": "awsui_with-text_8cbea_1ucra_131",
  "with-no-text": "awsui_with-no-text_8cbea_1ucra_140",
  "root": "awsui_root_8cbea_1ucra_145",
  "segment-part": "awsui_segment-part_8cbea_1ucra_177",
  "grouped": "awsui_grouped_8cbea_1ucra_201",
  "grouped-only": "awsui_grouped-only_8cbea_1ucra_201",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_1ucra_205",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_1ucra_216",
  "grouped-in-validation": "awsui_grouped-in-validation_8cbea_1ucra_223",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_1ucra_237",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_1ucra_257",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_8cbea_1ucra_278",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_1ucra_300",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_1ucra_321",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_1ucra_341",
  "grouped-vertical-only": "awsui_grouped-vertical-only_8cbea_1ucra_362",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_1ucra_384",
  "grouped-validation": "awsui_grouped-validation_8cbea_1ucra_388",
  "select": "awsui_select_8cbea_1ucra_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_1ucra_405",
  "segment-count-3": "awsui_segment-count-3_8cbea_1ucra_412",
  "segment-count-4": "awsui_segment-count-4_8cbea_1ucra_419",
  "segment-count-5": "awsui_segment-count-5_8cbea_1ucra_426",
  "segment-count-6": "awsui_segment-count-6_8cbea_1ucra_433",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_1ucra_440"
};
  